import gql from 'graphql-tag'

export const fetchRolesSelect = () => {
	return {
		query: gql`
			{
				roles: roles(where: { active: { _eq: true } }, order_by: { rol: asc }) {
					id
					name: rol
				}
			}
		`
	}
}
